import axios from "axios";
import { baseUrl } from "../config/api-config";
import { buildQuery } from "../config/api-config";

export const getCrmLeadsList = (query, token) => {
  let qs = buildQuery(query);
  let url = `${baseUrl}/crmlead-list${qs}`;
  return axios.get(url, {
    headers: {
      authorization: token,
    },
  });
};

export const createCrmLeads = (data, token) => {
  return axios.post(`${baseUrl}/crmlead_insert`, data, {
    headers: {
      authorization: token,
    },
  });
};

export const deleteCrmLeads = (id, token) =>
  axios.delete(`${baseUrl}/crmlead_del/${id}`, {
    headers: {
      authorization: token,
    },
  });

export const updateCrmLeads = (id, data, token) =>
  axios.put(`${baseUrl}/crmlead_update/${id}`, data, {
    headers: {
      authorization: token,
    },
  });

export const getCrmLeadsById = (id, token) =>
  axios.get(`${baseUrl}/crmlead_byid/${id}`, {
    headers: {
      authorization: token,
    },
  });
export const getIndustryList = (token) => {
  let url = `${baseUrl}/industry-list`;
  return axios.get(url, {
    headers: {
      authorization: token,
    },
  });
};
export const getStageList = (token) => {
  let url = `${baseUrl}/stages-list`;
  return axios.get(url, {
    headers: {
      authorization: token,
    },
  });
};
export const getCrmCompanyList = (token) => {
  let url = `${baseUrl}/crm-company-list`;
  return axios.get(url, {
    headers: {
      authorization: token,
    },
  });
};

/////***Tabs in viewsales page api***/////

export const getCrmFollowUpList = (query, token) => {
  let qs = buildQuery(query);
  let url = `${baseUrl}/crmfollow_up-list${qs}`;
  return axios.get(url, {
    headers: {
      authorization: token,
    },
  });
};
export const getCrmContactsList = (query, token) => {
  let qs = buildQuery(query);
  let url = `${baseUrl}/crmcontact-list${qs}`;
  return axios.get(url, {
    headers: {
      authorization: token,
    },
  });
};
export const getCrmNotesList = (query, token) => {
  let qs = buildQuery(query);
  let url = `${baseUrl}/crmnotes-list${qs}`;
  return axios.get(url, {
    headers: {
      authorization: token,
    },
  });
};

export const createCrmLeadFollowUp = (data, token) => {
  return axios.post(`${baseUrl}/crmleadFollowup_insert`, data, {
    headers: {
      authorization: token,
    },
  });
};
export const createCrmLeadContact = (data, token) => {
  return axios.post(`${baseUrl}/crmleadContact_insert`, data, {
    headers: {
      authorization: token,
    },
  });
};
export const createCrmLeadNote = (myFile, query, token) => {
  let qs = buildQuery(query);
  return axios.post(`${baseUrl}/crmleadNote_insert${qs}`, myFile, {
    headers: {
      authorization: token,
    },
  });
};
export const getCrmPdfViewer = (id, token) => {
  let url = `${baseUrl}/downloadcrmleadfile/${id}`;
  return axios.get(url, {
    headers: {
      authorization: token,
    },
    responseType: "blob",
  });
};
///crm leads emails and calls api
export const getCrmLeadsEmailsList = (query, token) => {
  let qs = buildQuery(query);
  let url = `${baseUrl}/getLeadFollowupEmails${qs}`;
  return axios.get(url, {
    headers: {
      authorization: token,
    },
  });
};
export const getCrmLeadsCallsList = (query, token) => {
  let qs = buildQuery(query);
  let url = `${baseUrl}/getLeadFollowupCalls${qs}`;
  return axios.get(url, {
    headers: {
      authorization: token,
    },
  });
};
export const getCrmLeadsLinkedInList = (query, token) => {
  let qs = buildQuery(query);
  let url = `${baseUrl}/getLeadFollowupLinkedinChat${qs}`;
  return axios.get(url, {
    headers: {
      authorization: token,
    },
  });
};
export const postCrmLeadsEmail = (data, token) =>
  axios.post(`${baseUrl}/insertLeadFollowupEmail`, data, {
    headers: {
      authorization: token,
    },
  });
export const postCrmLeadsCall = (data, token) =>
  axios.post(`${baseUrl}/insertLeadFollowupCall`, data, {
    headers: {
      authorization: token,
    },
  });
export const postCrmLeadsLinkedIn = (data, token) =>
  axios.post(`${baseUrl}/insertLeadFollowupLinkedinChat`, data, {
    headers: {
      authorization: token,
    },
  });
